// Lib
import React from 'react';
import useSelectionMarqueeList from './useSelectionMarqueeList';

// TODO: Replace all usages of this decorator with useSelectionMarqueeList
export default function <Props>(DecoratedComponent: React.ComponentType<Props>) {
    const SelectionMarqueeListDecorator = (props: Props) => {
        const selectionMarqueeListProps = useSelectionMarqueeList();

        return <DecoratedComponent {...props} {...selectionMarqueeListProps} />;
    };

    return SelectionMarqueeListDecorator;
}
